<template>
  <div class="main-content">
    <div class="container cv-content">
      <div class="cv-element" v-for="e in contents">
        <h3 style="margin-bottom: 12px">{{e.title}}</h3>
        <table class="table table-borderless table-sm" v-if="e.type === 'table' || e.type === 'listed-table'">
          <tr v-for="row in e.content">
            <td :class="e.style_title" v-html="'&blacksquare; ' + row[0]" v-if="e.type === 'listed-table'"></td>
            <td :class="e.style_title" v-html="row[0]" v-else></td>
            <td :class="e.style_content" v-html="row[1]"></td>
          </tr>
        </table>
        <ul v-else-if="e.type === 'list'">
          <li v-for="row in e.content" class="info-list-row">
            <span :class="e.style_title" v-html="row[0]"></span>
            <span :class="e.style_content" v-html="row[1]"></span>
          </li>
        </ul>
        <div v-else>
          <p v-for="row in e.content">
            <span :class="e.style_title" v-html="row[0]"></span>
            <span :class="e.style_content" v-html="row[1]"></span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  components: {},
  data() {
    return {
      contents: [{
        order: 1000,
        type: 'text',
        title: "Introduction",
        style_title: "info-title",
        style_content: "info-content",
        content: [
          ["Developer, Researcher, Instructor, and Maker <br> " +
          "I am a research officer at Agency for Defense Development(ADD)."]
        ]
      },
        {
          order: 1010,
          title: "Education",
          type: 'list',
          style_title: "info-edu",
          style_content: "info-regular",
          content: [
            ["<b>KAIST (Korea Advanced Institute of Science and Technology)</b><br>",
              "B.S., School of Computing (Computer Science), Mar. 2015 ~ Feb. 2019<br>" +
              "&dash; Summa Cum Laude, Excellence in Leadership and Volunteer Activity<br>" +
              "&dash; GPA 4.00/4.30 (96.67/100), CS Major GPA 4.04/4.30<br>" +
              "&dash; Jul. 2017. Summer session (exchange program) at DTU (Technical University of Denmark)"],
            ["<b>Hansung Science High School</b><br>", "Mar. 2013 ~ Feb. 2015"],
          ]
        },
        {
          order: 1100,
          title: "Research Interests",
          type: 'text',
          content: [
            ["Cyber-Physical System, Human-Computer Interaction, Machine Learning"]
          ]
        },
        {
          order: 1200,
          title: "Contact",
          type: "listed-table",
          style_title: "info-bold",
          style_content: "info-regular",
          content: [
            ["E-mail ", "rangewing@kaist.ac.kr<br>rangewing@wingdev.kr"],
            ["Homepage ", "<a href='http://wingdev.kr' style='padding-left: 0;'>wingdev.kr <i class='fas fa-external-link-alt ext-link'></i></a>"],
          ]
        }
      ]}
  }
}
</script>

<style>
#app {
}

.nav-link.nav-item-about {
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue